var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorHistoricalMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11924_16834)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11924_16834",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 18.3327C11.0998 18.334 12.1838 18.1191 13.195 17.7002C14.2062 17.2813 15.1247 16.6668 15.8977 15.8919C16.6726 15.1189 17.2872 14.2004 17.7061 13.1892C18.125 12.1779 18.3399 11.0939 18.3385 9.99936C18.3399 8.90481 18.125 7.82078 17.7061 6.80956C17.2872 5.79834 16.6726 4.87984 15.8977 4.10686C15.1247 3.33192 14.2062 2.71736 13.195 2.29849C12.1838 1.87961 11.0998 1.66467 10.0052 1.66602C8.91067 1.66467 7.82664 1.87961 6.81542 2.29849C5.80419 2.71736 4.8857 3.33192 4.11271 4.10686C3.33778 4.87984 2.72322 5.79834 2.30435 6.80956C1.88547 7.82078 1.67053 8.90481 1.67188 9.99936C1.67053 11.0939 1.88547 12.1779 2.30435 13.1892C2.72322 14.2004 3.33778 15.1189 4.11271 15.8919C4.8857 16.6668 5.80419 17.2813 6.81542 17.7002C7.82664 18.1191 8.91067 18.334 10.0052 18.3327Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0065 15.4159C10.2828 15.4159 10.5477 15.3061 10.7431 15.1108C10.9384 14.9154 11.0482 14.6505 11.0482 14.3742C11.0482 14.0979 10.9384 13.833 10.7431 13.6376C10.5477 13.4423 10.2828 13.3325 10.0065 13.3325C9.73024 13.3325 9.46529 13.4423 9.26994 13.6376C9.07459 13.833 8.96484 14.0979 8.96484 14.3742C8.96484 14.6505 9.07459 14.9154 9.26994 15.1108C9.46529 15.3061 9.73024 15.4159 10.0065 15.4159Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 4.99951V11.6662",
    stroke: "black",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11924_16834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 -0.000488281H20.0039V19.9995H0.00390625V-0.000488281Z",
    fill: "#f7702f"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11924_16834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorHistoricalMessage);
export default __webpack_public_path__ + "static/media/errorHistoricalMessage.1e3b12317a570b262a709a1b9fa3bae8.svg";
export { ForwardRef as ReactComponent };